import {positionLogo, mobileHeader, mobileAd} from '$c3local/header.js';
import {initAccordions, initCounters, checkMobileHeader, initBannerSwiper} from '$c3local/layout.js';
import {hideMobileAds, initBranchSearch, initOfferSearch, initShareLinks} from '$c3local/content.js';
import {initSponsorMap, sponsorListFilter} from '$c3local/sponsors.js';
import {initRecruitingFilters, initRecruitingSearch} from '$c3local/recruiting.js';
import {initPlayers} from '$c3local/player.js';
import {initNewsSlider} from '$c3local/news.js';
import {initSocials} from '$c3local/socials.js';
import {initPartnerFilter, initPartnerSwiper} from '$c3local/partner.js';
import {initInterstitials} from '$c3local/interstitials.js';
import {replaceFailedThumbnails} from '$c3local/youtube.js';
import {overrideCheckFunction} from '$c3base/check-mobile-nav.js';
import {initMasonry} from '$c3local/gallery.js';

overrideCheckFunction(() => {
});

$(function () {
    //hideMobileAds();
    initCounters();
    initAccordions();
    positionLogo();
    checkMobileHeader();
    mobileHeader();
    initPartnerSwiper();
    sponsorListFilter();
    initSponsorMap().catch(console.log);
    initShareLinks();
    initRecruitingFilters().catch(console.log);
    initRecruitingSearch();
    initBranchSearch();
    initOfferSearch();
    initPlayers();
    initNewsSlider();
    initSocials();
    initPartnerFilter();
    initBannerSwiper();
    initInterstitials();
    replaceFailedThumbnails();
    mobileAd();
    initMasonry();
});

$(window).on('load', function (e) {
    checkMobileHeader();
});

$(window).on('resize', function (e) {
    checkMobileHeader();
});
